export * as v1 from './v1'
export * as v2 from './v2'
export * as commons from './commons'
export * as universal from './universal'

import * as v1 from './v1'
import * as v2 from './v2'

export { VERSION } from './version'

export const allVersions = [v1, v2]
